<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()

// 应用初始化时初始化认证状态
// XSRF Token 会在以下时机自动刷新：
// 1. 首次需要时（POST/PUT/DELETE请求）自动初始化
// 2. 用户登录时强制刷新（匹配新用户）
// 3. Token刷新时强制刷新（保持同步）
onMounted(async () => {
  try {
    // 初始化认证状态（内部可能调用refreshToken，会自动刷新XSRF Token）
    await authStore.initAuth()

    // 如果用户已登录，刷新用户详细信息
    if (authStore.isAuthenticated) {
      await authStore.refreshUserInfo()
    }
  } catch (error) {
    console.warn('Failed to initialize app:', error)
  }
})
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  min-height: 100vh;
}

body {
  margin: 0;
  padding: 0;
}
</style>